import { useState, useEffect, useScriptsLoader } from 'sb-hooks'
import config from 'app-config'


type Result = {
  isFetching: boolean
  isLoaded: boolean
  error: Error
}

const testUrl = 'https://static-na.payments-amazon.com/OffAmazonPayments/us/sandbox/js/Widgets.js'
const prodUrl = 'https://static-na.payments-amazon.com/OffAmazonPayments/us/js/Widgets.js'
const scriptUrl = config.runEnv === 'prod' ? prodUrl : testUrl

const useAmazonPay = (): Result => {
  const script = useScriptsLoader([ scriptUrl ])

  const [ isAmazonReady, setAmazonReadyState ] = useState(Boolean(window.OffAmazonPayments))

  useEffect(() => {
    if (!isAmazonReady) {
      let loginReady = false
      let paymentsReady = false

      const checkReady = () => {
        if (loginReady && paymentsReady) {
          setAmazonReadyState(true)
        }
      }

      window.onAmazonLoginReady = () => {
        loginReady = true
        checkReady()
      }

      window.onAmazonPaymentsReady = () => {
        paymentsReady = true
        checkReady()
      }
    }
  }, [])

  const isLoaded = script.isLoaded && isAmazonReady
  const isFetching = script.isFetching || !isAmazonReady
  const error = script.error

  return {
    isFetching,
    isLoaded,
    error,
  }
}


export default useAmazonPay
